export type ChallengeStarMultiplier = 1 | 2 | 3;

const CHALLENGE_STAR_TIERS: readonly ChallengeStarMultiplier[] = [3, 2, 1];

export function assignChallengeStarTiers(
  entries: ReadonlyArray<{ playerId: string; score: number }>,
): Map<string, ChallengeStarMultiplier> {
  const result = new Map<string, ChallengeStarMultiplier>();
  let tierIndex = 0;
  let currentScore: number | undefined;

  for (const entry of entries) {
    if (currentScore === undefined) {
      currentScore = entry.score;
    } else if (entry.score !== currentScore) {
      tierIndex += 1;
      if (tierIndex >= CHALLENGE_STAR_TIERS.length) break;
      currentScore = entry.score;
    }
    result.set(entry.playerId, CHALLENGE_STAR_TIERS[tierIndex]!);
  }

  return result;
}
